import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialog,
  MatDialogModule,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface ThredAlertData {
  title?: string;
  mainText?: string;
  subText?: string;
  mode?: 'success' | 'error' | 'info';
}

@Component({
  selector: 'thred-alert-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [MatDialog],
})
export class AlertDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ThredAlertData) {}

  getMode() {
    return this.data.mode;
  }

  getIcon() {
    if (this.data.mode == 'error') {
      return 'error_outline';
    } else if (this.data.mode == 'success') {
      return 'check';
    } else if (this.data.mode == 'info') {
      return 'info';
    }
    return '';
  }
}
